export class LoginState {
    returnUrl: string;
    state: string;
}

export class CallbackResult {
    returnUrl: string
}

export class AuthenticationConfiguration {

    clientId: string;
    scope: string;
    responseType: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    userInfoUri: string;
    authenticateUrl: string;
    logoutUri: string;

    constructor() {
    }
}

export class AuthenticatedUserData {

    accessToken: string;
    idToken: string;

    constructor() {

    }
}
